import React, { useEffect, useRef, useState } from 'react'
import GenericWizardComponent from '../../genericComponents/GenericWizardComponent';
import GenericFormFooterComponent from '../../genericComponents/forms/GenericFormFooterComponent';
import NoDataFound from '../../genericComponents/NoDataFound';
import GenericFormComponent from '../../genericComponents/forms/GenericFormComponent';
import { dispatchHandler } from '../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import UploadExcelSkeletons from './UploadExcelSkeletons';
import GenericCustomButton from '../../genericComponents/GenericCustomButton';
import { finalSubmitMandatoryValidationsCheck, getMenuMode } from '../../helper/helperTableFunctions';
import '../../styles/stylesheets/home/Header.scss'
import Icons from '../../assets/icons';
import SpreadsheetComponent from 'react-spreadsheet-component'
import readXlsxFile from 'read-excel-file'
import IconsPath from '../../assets/icons'
import ParentModal from '../../genericComponents/ParentModal.jsx';
import './UploadExcel.scss'
import GenericConfirmationModal from '../../genericComponents/GenericConfiramationModal.jsx';
import UploadExcelInfo from './UploadExcelInfo.jsx';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import GenericInput from '../../genericComponents/input/GenericInputComponent.jsx';
import useCustomToast from '../../hooks/useCustomToast.js';
import LanguageTranslator from '../../locals/LanguageTranslator.js';
import { parseJwt } from '../../helper/genericFunction.js';
import { v4 as uuidv4 } from 'uuid';
import { getPermissionKey } from '../../helper/permissions.js';
import SpreadsheetWithHeaders from './SpreadsheetWithHeaders.jsx';
import ErrorLogsDetails from './ErrorLogsDetails.jsx';
import { Check, CheckCheck, ChevronDown, ClipboardList, HandCoins, TriangleAlert, Undo2, X } from 'lucide-react';
let Dispatcher = require('../../../node_modules/react-spreadsheet-component/lib/dispatcher.js');

const UploadExcel = (props) => {

    let { mode = "normal", procLineItemConfig = {}, updatePaload, className = '', stepsComponentClassName = '' } = props || {}
    let { keyName = "" } = procLineItemConfig || {};

    const location = useLocation();

    console.log("location", location)

    const [isFromProc, setIsFromProc] = useState(props?.isFromProc || false);

    const [currentStep, setCurrentStep] = useState(0);
    // to store the data of the Generic Form Component
    const [inputState, updateInputState] = useState([]);
    const [errorData, setErrorData] = useState([]);
    // State: To store the selected excel file by the user
    const [currentExcelFile, setCurrentExcelFile] = useState(null);
    // State: To store the updated Excel sheet with applied mapping of data.
    const [updatedCurrentExcelFile, setUpdatedCurrentExcelFile] = useState(null);
    // To store the template types list
    const [excelTypeList, setExcelTypeList] = useState([]);
    // Store the loading of the next button when current step is 0.
    const [buttonLoading, setButtonLoading] = useState(false);
    // State: To store the response from the upload file api.
    const [uploadFileResponse, setUploadFileResponse] = useState(null);
    // State: To check if the user has clicked submit or not
    const [submitLoading, setSubmitLoading] = useState(false);
    // State: To store the response of the api from the validation data.
    const [validateDataResponse, setValidateDataResponse] = useState({});
    // State: To store the case if the user has validated data and has not made any changes;
    const [isValidateDisabled, setIsValidateDisabled] = useState(false);
    // State: To store if the data is validated or not
    const [isCurrentDataValidated, setIsCurrentDataValidated] = useState(false);

    const customToast = useCustomToast();

    // States to be used in case of procurement upload excel
    const [updatedProcExcelData, setUpdatedProcExcelData] = useState({});
    // Will have data in format of = {
    //     "breakpoint" : [
    //         "data of breakpoint"
    //     ]
    // }

    // State: To store the current expanded data inside this state'
    const [currentExpandedBreakpoint, setCurrentExpandedBreakpoint] = useState("");

    // To hadnle the copy functionality inside the summary page
    const [copied, setCopied] = useState(false);
    // State : To store the config keys response
    const [configKeys, setConfigKeys] = useState({});
    // State : To store the last uploaded file
    const [lastUploadedFile, setLastUploadedFile] = useState(null);
    // State : To store the active tab 
    const [currentTab, setCurrentTab] = useState("mandatory")


    const currentStepRef = useRef(currentStep);

    const getSystemConfigKeysData = useSelector(state => state?.digivendStore?.getSystemConfigKeysData);
    const getTableComponentListData = useSelector(state => state?.generalStore?.getTableComponentListData);

    const handleCopy = (textCopy) => {
        navigator.clipboard.writeText(textCopy);
        setCopied(true)
    }

    useEffect(() => {
        if (copied)
            setTimeout(() => {
                setCopied(false);
            }, 3000)
    }, [copied])
    const history = useHistory();
    const [selectedModal, setSelectedModal] = useState(false);
    const generalStore = useSelector(state => state.generalStore)
    const masterDbStore = useSelector(state => state.masterDbStore);
    const digiArsStore = useSelector(state => state.digiArsStore)
    const dispatch = useDispatch()
    const [skipStep, setSkipStep] = useState(false);
    const [failedValidationRow, setFailedValidationRow] = useState({})

    const [focusedElement, setFocusedElement] = useState("")


    // Function : To check the if the user is creating a sales indent 
    const isUserCreatingSalesIndent = () => {
        return inputState?.[0]?.["value"]?.["key"] == "SALES_INDENTS"
    }

    // Function: To check if we have to run the proc methods or not
    const isRunProcMethods = () => {
        return isFromProc || ["PURCHASE_INDENT", "PURCHASE_ORDER", "PURCHASE_ORDER_UPLOAD", "PURCHASE_INDENT_UPLOAD", "PURCHASE_ORDER_DETAIL_UPLOAD", "PURCHASE_INDENT_DETAIL_UPLOAD", "CUSTOM_PURCHASE_ORDER_UPLOAD", "PRODUCT_CATALOGUE_TO_INDENT_UPLOAD", "PURCHASE_ORDER_ICODE_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) || isUserCreatingSalesIndent?.()
    }

    const isRunMethodFromDigiProcGenericExcel = () => {
        return ["PURCHASE_ORDER_UPLOAD", "PURCHASE_INDENT_UPLOAD", "PRODUCT_CATALOGUE_TO_INDENT_UPLOAD", "PURCHASE_ORDER_ICODE_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"])
    }

    useEffect(() => {
        if (skipStep) {
            setSkipStep(false);
            switchStep("next")
        }
    }, [skipStep])


    useEffect(() => {
        // Call for the template api.
        if (isFromProc) {
            dispatchHandler(dispatch, "getProcExcelTemplateRequest", {
                dropDownKey: "DIGIPROC_EXCEL_HEADER"
            }, getPermissionKey("purchase", "excelupload", "upload"));
        } else {
            dispatchHandler(dispatch, "getGenericExcelTemplateRequest", null, getPermissionKey("common", "commonfunctionality", "upload"));
        }

        // Call for the config keys api.
        dispatchHandler(dispatch, "getSystemConfigKeysRequest", null, getPermissionKey("common", "commonfunctionality", "upload"))

    }, [])

    useEffect(() => {
        const unsubscribe =  Dispatcher.subscribe('dataChanged', (data) => {
            if (currentStepRef.current === 3) {
                if (isRunProcMethods?.()) {
                    let updatedData = { ...updatedProcExcelData };
                    updatedData[currentExpandedBreakpoint] = data?.rows;
                    setUpdatedProcExcelData(updatedData);
                } else {
                    setUpdatedCurrentExcelFile(data.rows);
                }
            } else
                setCurrentExcelFile(data.rows);
            setIsValidateDisabled(false);
            setIsCurrentDataValidated(false);
        }, "spreadsheet-1");

        return () => {
            unsubscribe?.();  // remove listener on unmount
        };
    }, [inputState?.[0]?.["value"]?.["key"], currentExpandedBreakpoint])

    // Keep ref updated
    useEffect(() => {
        currentStepRef.current = currentStep;
    }, [currentStep]);

    // useEffect(() => {
    //     if (!isFromProc) {
    //         if (isUserCreatingSalesIndent?.()) {
    //             const unsubscribe = Dispatcher.subscribe('dataChanged', (data) => {
    //                 if (currentStepRef.current === 3) {
    //                     let updatedData = { ...updatedProcExcelData };
    //                     updatedData[currentExpandedBreakpoint] = data?.rows;
    //                     setUpdatedProcExcelData(updatedData);
    //                 } else
    //                     setCurrentExcelFile(data.rows);
    //                 setIsValidateDisabled(false);
    //                 setIsCurrentDataValidated(false);
    //             }, "spreadsheet-1")

    //             return () => {
    //                 unsubscribe?.();  // remove listener on unmount
    //             };

    //         }
    //     }
    // }, [inputState?.[0]?.["value"]?.["key"]])

    useEffect(() => {
        if (getSystemConfigKeysData?.isSuccess) {
            setConfigKeys({
                // Backup limit is going to be 1000.
                "EXCEL_UPLOAD_ROWS_LIMIT": getSystemConfigKeysData?.data?.resource?.["EXCEL_UPLOAD_ROWS_LIMIT"] || 1000,
                "EXCEL_VALIDATION_SUBMIT_SEND_TO_QUEUE": getSystemConfigKeysData?.data?.resource?.["EXCEL_VALIDATION_SUBMIT_SEND_TO_QUEUE"] ?? "FALSE",
            })
        }
    }, [getSystemConfigKeysData?.isSuccess])

    console.log("thisisthe input state", inputState, excelTypeList)

    const transformTemplates = (data) => {
        return data.map(item => {
            const parsedJson = item.json_data ? JSON.parse(item.json_data) : {};

            return {
                key: item.template_key,
                value: item.display_name,
                headers: parsedJson?.headers || null,
                template: item.templatePath,
                excelHeader: parsedJson.excelHeader || null,
                mandateHeader: parsedJson.mandateHeader || null,
                pageLink: item.page_link,
                tab: item.redirection_tab || null,
                turncateReq: item.truncate_req || null
            };
        });
    }

    useEffect(() => {
        if (generalStore?.["getGenericExcelTemplateData"]?.isSuccess) {
            let data = transformTemplates(generalStore?.["getGenericExcelTemplateData"]?.data?.resource)
            // let data = generalStore?.["getGenericExcelTemplateData"]?.data?.resource;
            if (mode == "procLineItemExcel") {
                let lineItemExcelItem = data?.find(val => val?.key == keyName);
                if (lineItemExcelItem) {
                    updateInputState(prev => {
                        prev[0] = {
                            "value": lineItemExcelItem
                        }
                        return prev;
                    })
                }
            } else {
                if (data?.[0]) {
                    let selectedItem = data[0];
                    if (location?.state?.template) {
                        selectedItem = data.find(item => item.key === location?.state?.template) || data[0];
                    }
                    updateInputState(prev => {
                        prev[0] = {
                            "value": selectedItem
                        }
                        return prev;
                    })
                }
            }
            setExcelTypeList(data || []);
        }
    }, [generalStore?.["getGenericExcelTemplateData"]?.isSuccess]);

    useEffect(() => {
        if (digiArsStore?.downloadTemplateData?.isSuccess) {
            window?.open(digiArsStore?.downloadTemplateData?.data?.resource || "");
        }
    }, [digiArsStore?.downloadTemplateData?.isSuccess])

    // On change of the template, call for the last uploaed file
    useEffect(() => {
        if (inputState?.[0]?.["value"]?.["value"]) {
            getLastUploadedFile()
        } else {
            setLastUploadedFile(null);
        }
    }, [inputState?.[0]?.["value"]?.["value"]])

    // Handle the response for the last uploaded file 
    useEffect(() => {
        if (getTableComponentListData?.isSuccess && getTableComponentListData?.data?.resource?.file_path) {
            setLastUploadedFile(getTableComponentListData?.data?.resource || {});
        }
    }, [getTableComponentListData?.isSuccess])

    // In case of proc set the template according to this
    useEffect(() => {
        if (generalStore?.["getProcExcelTemplateData"]?.isSuccess) {
            let data = generalStore?.["getProcExcelTemplateData"]?.data?.resource || {};
            let updatedExcelList = [];

            let indentTemplate = {
                excelHeader: data?.["excelHeader"] || {},
                value: "Purchase Indent",
                key: "PURCHASE_INDENT",
                mandateHeader: data?.["mandateHeader"] || {},
            }

            updatedExcelList.push(indentTemplate)

            updatedExcelList.push({
                excelHeader: data?.["excelHeader"] || {},
                value: "Purchase Order",
                key: "PURCHASE_ORDER",
                mandateHeader: data?.["mandateHeader"] || {},
            })
            setExcelTypeList(updatedExcelList);

            if (isFromProc) {
                updateInputState(prev => {
                    prev[0] = {
                        "value": indentTemplate
                    }
                    return prev;
                })
            }
        }
    }, [generalStore?.["getProcExcelTemplateData"]?.isSuccess])


    // Handle the response from the upload Excel api
    useEffect(() => {
        let parseToken = parseJwt(sessionStorage.getItem('token'));
        if (masterDbStore?.["uploadMasterDataImagesData"]?.isSuccess) {
            setUploadFileResponse(masterDbStore?.["uploadMasterDataImagesData"]?.data?.resource || null);
            setButtonLoading(true);
            // Get the data from the file and set it to the currentExcel file
            readXlsxFile(inputState?.[0]?.["uploadFile"]?.[0])?.then(rows => {
                let deleteRowOnTempletes = ["PRODUCTS_CATALOGUE_UPLOAD_FOOTWEAR", "PRODUCTS_CATALOGUE_UPLOAD_ACCESSORIES", "PRODUCTS_CATALOGUE_UPLOAD_APPREALS"], deleteRowOnTheseIds = ["8534", "754"];
                if (deleteRowOnTheseIds?.includes(parseToken?.schemaEntID) && deleteRowOnTempletes.includes(inputState?.[0]?.value?.key)) {
                    let indicesToRemove = [0, 2, 3];
                    rows = rows?.filter((_, index) => !indicesToRemove?.includes(index));
                    rows = rows?.map(row => row.slice(1));
                }
                rows = validateData(rows);
                rows = rows?.map(row =>
                    row.map(cell => (cell === 0 ? '0' : cell)) // Ensure each cell is checked
                ) || []
                let rowsLimit = Number(configKeys?.["EXCEL_UPLOAD_ROWS_LIMIT"] || "1000");
                if (rows?.length <= rowsLimit) {
                    setCurrentExcelFile(rows || []);
                    setCurrentStep(1);
                } else {
                    customToast({
                        "title": "Rows Validation Error!",
                        "description": `Uploaded excel number of rows should not exceed ${rowsLimit}!`,
                        "status": "error",
                    })
                }

                setButtonLoading(false)
            })
        }
    }, [masterDbStore?.["uploadMasterDataImagesData"]?.isSuccess])

    const checkDataValidation = (failedValidationRowParam = {}) => {
        let excelData = {}, breakPointKey = "";
        let currentHeaders = inputState?.[0]?.["value"]?.["excelHeader"] || {};
        // Function to get the payload data
        const getPayloadData = (data, excelHeaders) => {
            let values = [];
            data?.map((row, i) => {
                let obj = {};
                if (i !== 0) {
                    Object.keys(currentHeaders || {})?.map(headerKey => {
                        // Get the index of current headers in excel headers;
                        let index = excelHeaders?.findIndex(item => item === currentHeaders?.[headerKey]);
                        obj[headerKey] = index !== -1 ? row?.[index] ?? "" : ""
                    })
                    values.push(obj);
                }
            })
            return values;
        }

        if (isFromProc || isUserCreatingSalesIndent() || isRunProcMethods?.()) {
            if(inputState?.[2]?.["docno"]?.docno) {
                const findKeyByValue = (object, targetValue) => {
                for (const [outerKey, innerObject] of Object.entries(object)) {
                        for (const [innerKey, value] of Object.entries(innerObject)) {
                            if (value === targetValue) {
                                return innerKey;
                            }
                        }
                    }
                    return null;
                }
                breakPointKey = findKeyByValue(inputState?.[2] ||{}, inputState?.[2]?.["docno"]?.docno || "") || "";
            }
            excelData = {};
            Object.keys(updatedProcExcelData || {})?.map(breakpoint => {
                excelData[breakpoint] = getPayloadData(updatedProcExcelData?.[breakpoint] || [], updatedProcExcelData?.[breakpoint]?.[0]);
                if(Object.keys(failedValidationRowParam || {})?.length && Object.keys(failedValidationRowParam?.[breakpoint] || {})?.length) {
                    let indexesToRemove = Object.keys(failedValidationRowParam?.[breakpoint] || {}).map(Number);
                    excelData[breakpoint] = excelData[breakpoint]?.filter((_, index) => !indexesToRemove.includes(index));

                    if(excelData?.[breakpoint]?.length == 0) {
                        delete excelData[breakpoint]
                    }
                }
            });
        } else {
            excelData = getPayloadData(updatedCurrentExcelFile, updatedCurrentExcelFile?.[0]);
            if(Object.keys(failedValidationRowParam || {})?.length && Object.keys(failedValidationRowParam?.["sheet1"] || {})?.length) {
                let indexesToRemove = Object.keys(failedValidationRowParam?.["sheet1"] || {}).map(Number);
                excelData = excelData?.filter((_, index) => !indexesToRemove.includes(index));
            }
        }
        console.log("this is the data of the excel", excelData, failedValidationRowParam)
        const shouldDisableFromProc = (isFromProc || isRunProcMethods?.()) ? Object.keys(excelData || {})?.length == 0 ? true : Object.keys(excelData || {})?.some((breakpoint) => excelData[breakpoint]?.length === 0): excelData?.length === 0;
        return shouldDisableFromProc
    }

    console.log("this is the config", configKeys)

    // Handle the response of the validate file api
    useEffect(() => {
        if (generalStore?.["validateGenericExcelSheetData"]?.isSuccess) {
            if(configKeys?.EXCEL_VALIDATION_SUBMIT_SEND_TO_QUEUE?.toLowerCase() == "true" && isRunMethodFromDigiProcGenericExcel?.()) {
                setSubmitLoading(false);
                let updatedInputData = { ...inputState };
                updatedInputData[4] = generalStore?.["validateGenericExcelSheetData"]?.data?.resource || {};
                updateInputState({ ...updatedInputData });
                setCurrentStep(4);
            }
            else if (submitLoading) {
                setSubmitLoading(false);
                let updatedInputData = { ...inputState };
                updatedInputData[4] = generalStore?.["validateGenericExcelSheetData"]?.data?.resource || {};
                updateInputState({ ...updatedInputData });
                setCurrentStep(4);
            } else {
                if (isRunProcMethods?.()) {
                    let apiErrors = generalStore?.["validateGenericExcelSheetData"]?.data?.resource || {};
                    setValidateDataResponse(apiErrors);
                    console.log("this is checkFailedValidationRows", checkFailedValidationRows(apiErrors), "this is checkDataValidation", checkDataValidation(checkFailedValidationRows(apiErrors)))
                    if(Object.keys(checkFailedValidationRows(apiErrors) || {})?.length > 0 && !checkDataValidation(checkFailedValidationRows(apiErrors))) {
                        setSelectedModal("processNextWithFailedValidation")
                    }
                    setIsValidateDisabled(true);
                    if (Object.values(apiErrors || {})?.every(item => item?.["validation"] === "success")) {
                        setIsCurrentDataValidated(true);
                    }
                } else {
                    let apiErrors = generalStore?.["validateGenericExcelSheetData"]?.data?.resource?.sheet1 || {};
                    setValidateDataResponse(apiErrors);
                    if(Object.keys(checkFailedValidationRows(generalStore?.["validateGenericExcelSheetData"]?.data?.resource) || {})?.length > 0 && !checkDataValidation(checkFailedValidationRows(generalStore?.["validateGenericExcelSheetData"]?.data?.resource))) {
                        setSelectedModal("processNextWithFailedValidation")
                    }
                    setIsValidateDisabled(true);
                    if (apiErrors?.["validation"] === "success") {
                        setIsCurrentDataValidated(true);
                    }
                }
            }
            sessionStorage.removeItem("X-REQUEST-ID")
        }
    }, [generalStore?.["validateGenericExcelSheetData"]])

    // Handle the response of the submit api of the procurement excel upload
    useEffect(() => {
        if (generalStore?.["submitProcExcelData"]?.isSuccess) {
            let updatedInputData = { ...inputState };
            updatedInputData[4] = {
                "refNo": generalStore?.["submitProcExcelData"]?.data?.message?.split(':')?.[1]
            };
            setButtonLoading(false)
            updateInputState({ ...updatedInputData });
            setCurrentStep(4);
            setSubmitLoading(false);
        }
        if (generalStore?.["submitProcExcelData"]?.isError) {
            setButtonLoading(false)
        }
    }, [generalStore?.["submitProcExcelData"]?.isSuccess, generalStore?.["submitProcExcelData"]?.isError])

    // const checkFailedValidationRows = (res) => {
    //     // Step 1: Build a map of row -> issues
    //     const issueMap = {}; let prevKey = "";
    //     Object.keys(res || {})?.forEach((sheetKey) => {
    //         Object.entries(res?.[sheetKey]?.address || {}).forEach(([issueType, cellString]) => {
    //             if (!cellString) return;

    //             const cells = cellString.split(",");
    //             cells.forEach(cell => {
    //                 // Only process if it's a valid Excel-style cell reference (e.g., C4, AA12)
    //                 const validCellPattern = /^[A-Z]+[0-9]+$/i;
    //                 if (!validCellPattern.test(cell)) return; // Skip if not a valid cell like "C4"

    //                 let row = cell.match(/\d+/)?.[0]; // Extract row number
    //                 if(prevKey) {
    //                     row = row - updatedProcExcelData[prevKey]?.length
    //                 }
    //                 else {
    //                     row = row - 1
    //                 }
    //                 if (row || row === 0) {
    //                     issueMap[sheetKey] = { ...issueMap?.[sheetKey] || {} }
    //                     if (!issueMap[sheetKey][row]) issueMap[sheetKey][row] = [];
    //                     issueMap[sheetKey][row].push(issueType);
    //                 }
    //             });
    //         });
    //         prevKey = sheetKey;
    //     })

    //     setFailedValidationRow(issueMap);

    //     return issueMap
    // }

    const checkFailedValidationRows = (res) => {
        const issueMap = {};

        // Build cumulative offset: each sheet's API row numbers continue from
        // where the previous sheet left off (1-based, header not counted).
        // We convert to 0-based local index: localRow = absRow - runningOffset - 1
        const sheetKeys = Object.keys(res || {});
        let runningOffset = 0;

        sheetKeys.forEach((sheetKey) => {
            Object.entries(res?.[sheetKey]?.address || {}).forEach(([issueType, cellString]) => {
                if (!cellString) return;

                const cells = cellString.split(",");
                cells.forEach(cell => {
                    const validCellPattern = /^[A-Z]+[0-9]+$/i;
                    if (!validCellPattern.test(cell)) return;

                    const absRow = Number(cell.match(/\d+/)?.[0]);
                    // absRow 1 = header row of sheet1, so data rows start at absRow 2.
                    // localRow 0 = first data row of this sheet (array index after header).
                    const localRow = absRow - runningOffset - 1;

                    if (localRow >= 0) {
                        issueMap[sheetKey] = { ...(issueMap[sheetKey] || {}) };
                        if (!issueMap[sheetKey][localRow]) issueMap[sheetKey][localRow] = [];
                        issueMap[sheetKey][localRow].push(issueType);
                    }
                });
            });

            // Advance offset by this sheet's data row count (length - 1 for the header row)
            const sheetDataRows = (updatedProcExcelData?.[sheetKey]?.length ?? 1) - 1;
            runningOffset += sheetDataRows;
        });

        setFailedValidationRow(issueMap);
        return issueMap;
    };

    const finalSubmitWithFailValidation = (data = false) => {
        // setSubmitLoading(true);
        let tokenData = parseJwt(sessionStorage?.getItem("token"));
        sessionStorage.setItem("X-REQUEST-ID", uuidv4() + (tokenData.jti || ""));
        let currentHeaders = inputState?.[0]?.["value"]?.["excelHeader"] || {};
        let excelData, breakPointKey = "";
        // Create the excel files upload 

        // Function to get the payload data
        const getPayloadData = (data, excelHeaders) => {
            let values = [];
            data?.map((row, i) => {
                let obj = {};
                if (i !== 0) {
                    Object.keys(currentHeaders || {})?.map(headerKey => {
                        // Get the index of current headers in excel headers;
                        let index = excelHeaders?.findIndex(item => item === currentHeaders?.[headerKey]);
                        obj[headerKey] = index !== -1 ? row?.[index] ?? "" : ""
                    })
                    values.push(obj);
                }
            })
            return values;
        }
        const convertToInitialExcelFormat = (values, currentHeaders) => {
            if (!values || values.length === 0) return [];

            // Build the header row based on currentHeaders
            const headerRow = Object.values(currentHeaders);

            // Build data rows
            const dataRows = values.map(obj => {
                return Object.values(obj);
            });
            // Return full Excel-style data
            return [headerRow, ...dataRows];
        };

        if (isFromProc || isUserCreatingSalesIndent() || isRunProcMethods?.()) {
            if(inputState?.[2]?.["docno"]?.docno) {
                const findKeyByValue = (object, targetValue) => {
                for (const [outerKey, innerObject] of Object.entries(object)) {
                        for (const [innerKey, value] of Object.entries(innerObject)) {
                            if (value === targetValue) {
                                return innerKey;
                            }
                        }
                    }
                    return null;
                }
                breakPointKey = findKeyByValue(inputState?.[2] ||{}, inputState?.[2]?.["docno"]?.docno || "") || "";
            }
            excelData = {}; let getUpdatedData = {};
            Object.keys(updatedProcExcelData || {})?.map(breakpoint => {
                excelData[breakpoint] = getPayloadData(updatedProcExcelData?.[breakpoint] || [], updatedProcExcelData?.[breakpoint]?.[0]);
                if(Object.keys(failedValidationRow || {})?.length && Object.keys(failedValidationRow?.[breakpoint] || {})?.length) {
                    let indexesToRemove = Object.keys(failedValidationRow?.[breakpoint] || {}).map(Number);
                    excelData[breakpoint] = excelData[breakpoint]?.filter((_, index) => !indexesToRemove.includes(index));

                    if(excelData?.[breakpoint]?.length == 0) {
                        delete excelData[breakpoint]
                    }
                }
                if(excelData[breakpoint]) getUpdatedData[breakpoint] = convertToInitialExcelFormat(excelData[breakpoint], updatedProcExcelData?.[breakpoint]?.[0]);
            });
            setUpdatedProcExcelData(getUpdatedData);
        } else {
            let getUpdatedData = {};
            excelData = getPayloadData(updatedCurrentExcelFile, updatedCurrentExcelFile?.[0]);
            if(Object.keys(failedValidationRow || {})?.length && Object.keys(failedValidationRow?.["sheet1"] || {})?.length) {
                let indexesToRemove = Object.keys(failedValidationRow?.["sheet1"] || {}).map(Number);
                excelData = excelData?.filter((_, index) => !indexesToRemove.includes(index));
            }
            getUpdatedData = convertToInitialExcelFormat(excelData, updatedCurrentExcelFile?.[0])
            setUpdatedCurrentExcelFile(getUpdatedData)
        }
        
        let payload = (isFromProc || (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent?.())) ? data ? {
            additionalData: validateDataResponse || {},
            data: excelData || {},
            filePath: uploadFileResponse?.[0]?.filePath,
            isPO: inputState?.[0]?.["value"]?.["key"] == "PURCHASE_ORDER" ? true : false,
            totalItemCount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalQty || ""), 0) || "",
            totalPOCount: Object.keys(updatedProcExcelData || {})?.length || "",
            totalAmount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalNetAmount || ""), 0) || "",
            breakPointValue: isUserCreatingSalesIndent() && inputState?.[2]?.["docno"]?.docno ? inputState?.[2]?.["docno"]?.docno : undefined,
            breakPointKey: isUserCreatingSalesIndent() && breakPointKey ? breakPointKey : undefined
        } : {
            isPO: inputState?.[0]?.["value"]?.["key"] == "PURCHASE_ORDER" ? true : false,
            data: excelData
        } : {
            data: isRunProcMethods?.() ? excelData : { "sheet1": excelData },
            fileName: uploadFileResponse?.[0]?.fileName,
            filePath: uploadFileResponse?.[0]?.filePath,
            isSubmitExcel: data,
            uploadType: inputState?.[0]?.["value"]?.key,
            truncateReq: inputState?.[0]?.["value"]?.turncateReq || inputState?.[0]?.["value"]?.turncateReq === 0 ? inputState?.[0]?.["value"]?.turncateReq : "",
            ...(getMenuMode?.() == "new" ? {"menuMode" : "new"} : {}),
            ...(isRunProcMethods?.() ? {
                additionalData: validateDataResponse || {},
                totalItemCount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalQty || ""), 0) || "",
                totalPOCount: Object.keys(updatedProcExcelData || {})?.length || "",
                totalAmount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalNetAmount || ""), 0) || "",
                breakPointValue: inputState?.[2]?.["docno"]?.docno,
                breakPointKey: breakPointKey 
            } : {})
        }
        if ((isFromProc && data) || (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent?.()) && data) {
            setButtonLoading(true)
        }
        setCurrentExpandedBreakpoint("");
        setSelectedModal(false);
        dispatchHandler(dispatch, (isFromProc || (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent()))  ? data ? "submitProcExcelRequest" : "validateProcExcelRequest" : "validateGenericExcelSheetRequest", {...payload, apiUrl : (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent()) ? "/admin/digiproc/excel/validation" : undefined}, isFromProc ? getPermissionKey("purchase", "excelupload", "upload") : getPermissionKey("common", "commonfunctionality", "upload"));
    }

    // Handle the response of the validated excel file in case of proc
    useEffect(() => {
        if (generalStore?.["validateProcExcelData"]?.isSuccess) {
            if (submitLoading) {
                setSubmitLoading(false);
                let updatedInputData = { ...inputState };
                updatedInputData[4] = generalStore?.["validateProcExcelData"]?.data?.resource;
                updateInputState({ ...updatedInputData });
                setCurrentStep(4);
            } else {
                let apiErrors = generalStore?.["validateProcExcelData"]?.data?.resource || {};
                setValidateDataResponse(apiErrors);
                console.log("5445454554", checkFailedValidationRows(apiErrors));
                if(Object.keys(checkFailedValidationRows(apiErrors) || {})?.length > 0 && !checkDataValidation(checkFailedValidationRows(apiErrors))) {
                    setSelectedModal("processNextWithFailedValidation")
                }
                setIsValidateDisabled(true);
                if (Object.values(apiErrors || {})?.every(item => item?.["validation"] === "success")) {
                    setIsCurrentDataValidated(true);
                }
            }
        }
    }, [generalStore?.["validateProcExcelData"]?.isSuccess])

    // Get the last uploaded file
    const getLastUploadedFile = () => {
        setLastUploadedFile(null);
        if (inputState?.[0]?.["value"]?.["key"]) {
            dispatchHandler(dispatch, `getTableComponentListRequest`, {
                apiUrl: "/upload/get/last/template",
                uploadType: inputState?.[0]?.["value"]?.["key"],
            })
        }
    }

    const resetAllStates = () => {
        setCurrentStep(0);
        if (mode == "procLineItemExcel") {
            let lineItemExcelItem = excelTypeList?.find(val => val?.key == keyName);
            if (lineItemExcelItem) {
                updateInputState([
                    {
                        "value": lineItemExcelItem
                    }
                ])
            }
        }
        else {
            updateInputState([
                {
                    "value": excelTypeList?.[0]
                }
            ]);
        }
        setErrorData([]);
        setCurrentExcelFile(null);
        setUpdatedCurrentExcelFile(null);
        setUpdatedProcExcelData(null);
        setUploadFileResponse(null);
        setValidateDataResponse({});
        setIsValidateDisabled(false);
        setIsCurrentDataValidated(false);
    }

    // Function : to check if the date format is validated or not
    function isValidDateFormat(dateString) {
        const format = 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (India Standard Time)';
        return moment(dateString, format, true).isValid();
    }

    // Function to convert Excel serial number to date string (YYYY-MM-DD format)
    const excelSerialToDateString = (serial) => {
        const MS_PER_DAY = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
        const excelEpoch = new Date('1899-12-30'); // Excel's epoch date (one day before the JavaScript epoch)

        // Calculate the date by adding the number of days (given by the serial number) to the Excel epoch
        const date = new Date(excelEpoch.getTime() + serial * MS_PER_DAY);

        // Format the date as YYYY-MM-DD using JavaScript date methods
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // Month is zero-based
        const day = ('0' + date.getDate()).slice(-2);

        return `${year}-${month}-${day}`;
    }
    // Function -> To validate the uploaded excel file by the user.
    const validateData = (data) => {
        let temp = [];
        data?.map(function (value, index, arr) {
            let obj = [];
            // Removing the null rows from the excel
            if (!value?.every(item => item == null || item == "")) {
                value?.map((val, innerIndex) => {
                    // Check if the provided value is date if date then convert it into string.
                    if (isValidDateFormat(val)) {
                        obj.push(moment(val)?.format("YYYY-MM-DD"));
                    }
                    else if (index !== 0 && ["valid from", "valid to", "order date", "delivery date", "po valid from", "po valid to"]?.includes(data?.[0]?.[innerIndex]?.toLowerCase?.()) && typeof (val) == "number") {
                        obj.push(excelSerialToDateString(val));
                    }
                    else {
                        obj.push(val);
                    }
                })
                temp.push(obj);
            }
            return null;
        })
        return temp;
    }

    const processDataWithBreakpoints = (headers, rows) => {
        const result = [];
        let prevSite = null;
        let prevVendor = null;

        rows?.forEach((row, index) => {
            const site = row[headers.indexOf("Site Name")];
            const vendor = row[headers.indexOf("Factory")];

            // Breakpoint if SITE_NAME is different from previous
            if (prevSite !== null && site !== prevSite) {
                result.push({ type: "breakpoint", by: "Site Name", value: site });
            }

            // Breakpoint if SITE_NAME same but VENDOR_ID is different
            else if (site === prevSite && vendor !== prevVendor) {
                result.push({ type: "breakpoint", by: "Factory", value: vendor });
            }

            prevSite = site;
            prevVendor = vendor;
        });

        return result;
    };

    // Function -> To provide the initial mapped values for Map Column Step
    const provideMappedColumns = () => {
        let appliedExcelHeaders = currentExcelFile?.[0] || [];
        let headers = inputState?.[0]?.["value"]?.["excelHeader"] || {};
        let mappedColumns = {};
        let rowData = currentExcelFile?.slice(1), getDefaultBreakpoint = processDataWithBreakpoints(currentExcelFile?.[0], rowData), parseToken = parseJwt(sessionStorage.getItem('token'));;
        Object.keys(headers || {})?.map(headerKey => {
            // If the heder is availble inside the provided excel headers
            if (parseToken?.schemaEntID == "10512" && headerKey == "docno" && isRunProcMethods?.() && getDefaultBreakpoint?.length > 0) {
                mappedColumns[headerKey] = { [headerKey]: getDefaultBreakpoint?.[0]?.by }
            }
            else if (appliedExcelHeaders?.includes(headers?.[headerKey]))
                mappedColumns[headerKey] = { [headerKey]: headers?.[headerKey] }
        })
        return mappedColumns;
    }

    // Function -> To handle the step changes.
    const switchStep = (stepType) => {
        switch (currentStep) {
            case 0: {
                if (stepType == "back") {
                    setSelectedModal("backConfirmationModal");
                } else {
                    let inputFields = getInputFields();
                    let errorMessages = finalSubmitMandatoryValidationsCheck(inputFields, inputState?.[0], "label");
                    if (Object.keys(errorMessages || {})?.length > 0) {
                        let updatedErrorData = [...errorData];
                        updatedErrorData[0] = errorMessages;
                        setErrorData([...updatedErrorData]);
                    } else {
                        if (inputState?.[0]?.["uploadFile"]?.[0]) {
                            let formData = new FormData();
                            formData.append("file", inputState?.[0]?.["uploadFile"]?.[0]);
                            formData.append("filePath", "");
                            formData.append("removeFileName", "");
                            formData.append("copyFileName", "");
                            dispatchHandler(dispatch, "uploadMasterDataImagesRequest", formData, isFromProc ? getPermissionKey("purchase", "excelupload", "upload") : getPermissionKey("common", "commonfunctionality", "upload"));
                        }
                    }
                }
                break;
            }
            case 1: {
                if (stepType === "back") {
                    setCurrentStep(0);
                    setCurrentExcelFile(null);
                } else {
                    let updatedInputData = [...inputState];
                    updatedInputData[2] = provideMappedColumns() || {};
                    updateInputState([...updatedInputData]);
                    setCurrentStep(2);
                    setSkipStep(true);
                }
                break;
            }
            case 2: {
                if (stepType === "back") {
                    setCurrentStep(1);
                    let updatedInputData = [...inputState];
                    updatedInputData[2] = {};
                    updateInputState([...updatedInputData]);
                } else {
                    let inputFields = getInputFields();
                    let errorMessages = finalSubmitMandatoryValidationsCheck(inputFields, inputState?.[2], "label");
                    if (Object.keys(errorMessages || {})?.length > 0) {
                        let updatedErrorData = [...errorData];
                        updatedErrorData[2] = errorMessages;
                        setErrorData([...updatedErrorData]);
                    } else {
                        handleChange("adjustExcelData")
                        setCurrentStep(3);
                    }
                }
                break;
            }
            case 3: {
                if (stepType == "back")
                    setSelectedModal("confirmationModal");
                else {
                    setSubmitLoading(true);
                    handleChange("validateFile", true);
                }
                break;
            }
            case 4: {
                resetAllStates();
                break;
            }
            default: {

            }
        }
    }

    const getInputFields = () => {
        switch (currentStep) {
            case 0: {
                return [
                    // Choose Type Input Field.
                    {
                        key: "value", type: "dropdown", isDisabled: () => mode == "procLineItemExcel", label: "Choose Template", mandatory: true, genInputExtraClass: "gfb-choose", iconRight: <IconsPath.DownArrowNew />, inputProps: () => ({
                            headerKeys: { "value": {} },
                            itemKeys: { "value": ["value"] },
                            search: {
                                placeholder: "Search",
                                customSearchFunction: (listState, listFunctions) => {
                                    const { listData, currentSearch } = listState;
                                    return listData?.filter(item => item?.value.toLowerCase?.().includes(currentSearch?.toLowerCase()));
                                }
                            },
                            getListData: () => (excelTypeList || [])
                        }),
                        inputComponents: {
                            "bottom": () => {
                                return inputState?.[0]?.["value"]?.["value"] && <GenericCustomButton
                                    leftIcon={<Icons.DownloadExcelTemplateGreenIcon />}
                                    label="Download Template"
                                    onClick={() => handleChange("downloadTemplate", inputState?.[0]?.["value"])}
                                />
                            }
                        }
                    },
                    // Upload File input field.
                    {
                        key: "uploadFile", mandatory: true, type: "upload", genInputExtraClass: "gfb-upload", inputProps: () => ({
                            acceptFiles: ".xlsx,.xls,.csv",
                            maxSize: 200,
                            renderCustomPlaceholder: () => {
                                return (
                                    <div className='gibu-inner'>
                                        <div><IconsPath.UploadIcon /></div>
                                        <LanguageTranslator tag="h4">Drag & Drop files here</LanguageTranslator>
                                        <LanguageTranslator tag="p">Files supported : XLSX, XLS, CSV</LanguageTranslator>
                                        {/* <LanguageTranslator tag="span" className='generic-approve-btn h-[32px]'>Choose File</LanguageTranslator> */}
                                        <GenericCustomButton
                                            type='primary'
                                            label={'Choose File'}
                                            style={{ position: 'static' }}
                                            // className='!mt-[6px] !mb-3'
                                            className='!mt-[1px] !mb-[5px]'
                                        />
                                        <LanguageTranslator tag="p">Maximum Size : Upto 10 MB</LanguageTranslator>
                                    </div>
                                )
                            }
                        })
                    }
                ]
            }
            case 2: {
                let headers = inputState?.[0]?.["value"]?.["excelHeader"] || {};
                let mandateHeaders = inputState?.[0]?.["value"]?.["mandateHeader"] || {};
                let inputFields = Object.keys(headers)?.map(key => ({
                    key: key, type: "dropdown", iconRight: <Icons.DownArrowNew />, label: headers?.[key], mandatory: mandateHeaders?.[key] || false, inputProps: () => ({
                        search: {
                            placeholder: "Type To Search",
                            customSearchFunction: (listState) => {
                                const { listData, currentSearch } = listState;
                                return listData?.filter(item => item?.[key].toLowerCase().includes(currentSearch?.toLowerCase()));
                            }
                        },
                        headerKeys: { [key]: {} },
                        itemKeys: { [key]: [key] },
                        getListData: () => currentExcelFile?.[0]?.map(item => ({ [key]: item })) || [],
                    })
                }))
                return inputFields;
            }
            default:
        }
    }

    // Function to check if the next button is disabled or not
    const isNextDisabled = () => {
        let errorCondition = Object.keys(errorData?.[currentStep] || {})?.length > 0;
        switch (currentStep) {
            case 0: {
                return errorCondition || generalStore?.["getGenericExcelTemplateData"]?.isLoading
            }
            case 1: return currentExcelFile?.length <= 1;
            case 2: return errorCondition;
            case 3:  return !isCurrentDataValidated;
            default: {
                return errorCondition;
            }
        }
    }

    const handleChange = (type, data) => {
        switch (type) {
            case "downloadTemplate": {
                if (isFromProc) {
                    dispatchHandler(dispatch, "downloadTemplateRequest", {
                        "templateType": "DIGIPROC_EXCEL_UPLOAD",
                    }, getPermissionKey("purchase", "excelupload", "upload"))
                } else {
                    data?.template && window?.open(data?.template)
                }
                break;
            }
            // Validate excel file at current step is 3
            case "validateFile": {
                let tokenData = parseJwt(sessionStorage?.getItem("token"));
                if (!sessionStorage.getItem("X-REQUEST-ID")) {
                    sessionStorage.setItem("X-REQUEST-ID", uuidv4() + (tokenData.jti || ""));
                }
                let currentHeaders = inputState?.[0]?.["value"]?.["excelHeader"] || {};
                let excelData, breakPointKey = "";
                // Create the excel files upload 

                // Function to get the payload data
                const getPayloadData = (data, excelHeaders) => {
                    let values = [];
                    data?.map((row, i) => {
                        let obj = {};
                        if (i !== 0) {
                            Object.keys(currentHeaders || {})?.map(headerKey => {
                                // Get the index of current headers in excel headers;
                                let index = excelHeaders?.findIndex(item => item === currentHeaders?.[headerKey]);
                                obj[headerKey] = index !== -1 ? row?.[index] ?? "" : ""
                            })
                            values.push(obj);
                        }
                    })
                    return values;
                }
                if (isRunProcMethods?.()) {
                    if (inputState?.[2]?.["docno"]?.docno) {
                        const findKeyByValue = (object, targetValue) => {
                            for (const [outerKey, innerObject] of Object.entries(object)) {
                                for (const [innerKey, value] of Object.entries(innerObject)) {
                                    if (value === targetValue) {
                                        return innerKey;
                                    }
                                }
                            }
                            return null;
                        }
                        breakPointKey = findKeyByValue(inputState?.[2] || {}, inputState?.[2]?.["docno"]?.docno || "") || "";
                    }
                    excelData = {};
                    Object.keys(updatedProcExcelData || {})?.map(breakpoint => {
                        excelData[breakpoint] = getPayloadData(updatedProcExcelData?.[breakpoint] || [], updatedProcExcelData?.[breakpoint]?.[0]);
                    })
                } else {
                    excelData = getPayloadData(updatedCurrentExcelFile, updatedCurrentExcelFile?.[0]);
                }

                let payload = (isFromProc || (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent?.())) ? data ? {
                    additionalData: validateDataResponse || {},
                    data: excelData || {},
                    filePath: uploadFileResponse?.[0]?.filePath,
                    isPO: inputState?.[0]?.["value"]?.["key"] == "PURCHASE_ORDER" ? true : false,
                    totalItemCount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalQty || ""), 0) || "",
                    totalPOCount: Object.keys(updatedProcExcelData || {})?.length || "",
                    totalAmount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalNetAmount || ""), 0) || "",
                    breakPointValue: isUserCreatingSalesIndent() && inputState?.[2]?.["docno"]?.docno ? inputState?.[2]?.["docno"]?.docno : undefined,
                    breakPointKey: isUserCreatingSalesIndent() && breakPointKey ? breakPointKey : undefined
                } : {
                    isPO: inputState?.[0]?.["value"]?.["key"] == "PURCHASE_ORDER" ? true : false,
                    data: excelData
                } : {
                    data: isRunProcMethods?.() ? excelData : { "sheet1": excelData },
                    fileName: uploadFileResponse?.[0]?.fileName,
                    filePath: uploadFileResponse?.[0]?.filePath,
                    isSubmitExcel: data,
                    uploadType: inputState?.[0]?.["value"]?.key,
                    truncateReq: inputState?.[0]?.["value"]?.turncateReq || inputState?.[0]?.["value"]?.turncateReq === 0 ? inputState?.[0]?.["value"]?.turncateReq : "",
                    ...(getMenuMode?.() == "new" ? { "menuMode": "new" } : {}),
                    ...(isRunProcMethods?.() ? {
                        additionalData: validateDataResponse || {},
                        totalItemCount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalQty || ""), 0) || "",
                        totalPOCount: Object.keys(updatedProcExcelData || {})?.length || "",
                        totalAmount: Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalNetAmount || ""), 0) || "",
                        breakPointValue: inputState?.[2]?.["docno"]?.docno,
                        breakPointKey: breakPointKey
                    } : {}),
                    oldRefUUID: inputState?.[0]?.["value"]?.key == "OTB_MANAGE_EXCEL_UPLOAD" ? location?.state?.oldRefUUID : undefined
                }
                if ((isFromProc && data) || (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent?.()) && data) {
                    setButtonLoading(true)
                }

                if (updatePaload) {
                    payload = updatePaload(payload)
                }

                dispatchHandler(dispatch, (isFromProc || (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent())) ? data ? "submitProcExcelRequest" : "validateProcExcelRequest" : "validateGenericExcelSheetRequest", { ...payload, apiUrl: (getMenuMode?.() == "new" ? false : isUserCreatingSalesIndent()) ? "/admin/digiproc/excel/validation" : undefined }, isFromProc ? getPermissionKey("purchase", "excelupload", "upload") : getPermissionKey("common", "commonfunctionality", "upload"));
                break;
            }
            // Map the data according to the mapping created by user.
            case "adjustExcelData": {
                let file = JSON.parse(JSON.stringify(currentExcelFile));
                let headers = inputState?.[2];
                let excelHeaders = currentExcelFile?.[0];
                let updatedCurrentExcelFile = [];
                let currentHeaders = inputState?.[0]?.["value"]?.["excelHeader"] || {} || {}
                // Create the excel files upload 

                // In case when the user is using this for procurement.
                if (isRunProcMethods?.()) {
                    let updatedData = {};
                    let breakpointData = ["NA"];
                    let breakpointKey = inputState?.[2]?.["docno"]?.["docno"];
                    let breakpointIndex;
                    if (breakpointKey) {
                        // The index on which the header is set;
                        breakpointIndex = file?.[0]?.findIndex(header => header === breakpointKey);
                        let data = [];
                        file?.slice(1)?.map((row, i) => {
                            if (!data?.includes(row[breakpointIndex] || "NA")) {
                                data.push(row[breakpointIndex] || "NA")
                            }
                        })
                        breakpointData = data || [];
                    }


                    breakpointData?.map((key) => {
                        if (!updatedData?.[key]) {
                            updatedData[key] = [];
                        }
                        file?.map((row, i) => {
                            if (!updatedData?.[key]?.[i]) {
                                updatedData[key][i] = [];
                            }
                            if (i !== 0) {
                                // Check if the choosen breakpoint is present inside the current row data;
                                if (inputState?.[2]?.["docno"]?.["docno"] ? (row[breakpointIndex] ?? "") == (key == "NA" ? "" : key) : true) {
                                    // Mapping the current headers
                                    Object.keys(currentHeaders || {})?.map((current, currentIndex) => {
                                        let index = excelHeaders?.findIndex(item => item === headers?.[current]?.[current]);
                                        if (index !== -1) {
                                            updatedData[key][i][currentIndex] = row[index] === 0 ? '0' : row[index];
                                        }
                                        else
                                            updatedData[key][i][currentIndex] = "";
                                    })
                                }
                            } else {
                                updatedData[key][0] = Object.values(currentHeaders) || []
                            }
                        })
                        updatedData[key] = updatedData?.[key]?.filter(item => item?.length > 0);
                    })
                    setUpdatedProcExcelData(updatedData);
                } else {
                    file?.map((row, i) => {
                        if (!updatedCurrentExcelFile?.[i]) {
                            updatedCurrentExcelFile[i] = [];
                        }
                        if (i !== 0) {
                            Object.keys(currentHeaders)?.map((current, currentIndex) => {
                                let index = excelHeaders?.findIndex(item => item === headers?.[current]?.[current]);
                                if (index !== -1)
                                    updatedCurrentExcelFile[i][currentIndex] = row[index] === 0 ? '0' : row[index];
                                else
                                    updatedCurrentExcelFile[i][currentIndex] = "";
                            })
                        } else {
                            updatedCurrentExcelFile[0] = Object.values(currentHeaders) || []
                        }
                    })
                    setUpdatedCurrentExcelFile(updatedCurrentExcelFile);
                }

                break;
            }
            case "viewExcelUploadedPages": {
                if (inputState?.[0]?.["value"]?.key == "CATEGORY_SIZE_MBQ_DATA") {
                    let params = {
                        key: "categorySizeMbq",
                    }
                    let urlSearchParams = new URLSearchParams("?");
                    params && Object.keys(params)?.forEach((key) => {
                        urlSearchParams.append(key, encodeURIComponent(JSON.stringify(params[key])));
                    });
                    history.push({
                        pathname: inputState?.[0]?.["value"]?.pageLink?.replace('#', ''),
                        search: urlSearchParams?.toString(),
                    });
                }
                else if (inputState?.[0]?.["value"]?.key == "SITE_ASORTMENT_MBQ_DATA" || inputState?.[0]?.["value"]?.key == "SITE_ASORTMENT_MBQ_DATA_INC") {
                    let params = {
                        key: "siteAssortmentMbq",
                    }
                    let urlSearchParams = new URLSearchParams("?");
                    params && Object.keys(params)?.forEach((key) => {
                        urlSearchParams.append(key, encodeURIComponent(JSON.stringify(params[key])));
                    });
                    history.push({
                        pathname: inputState?.[0]?.["value"]?.pageLink?.replace('#', ''),
                        search: urlSearchParams?.toString(),
                    });
                }
                else if(["CUSTOMER_MASTER_UPLOAD", "CUSTOM_ITEM_MASTER_CREATE"]?.includes(inputState?.[0]?.["value"]?.key)) {
                    if (getMenuMode?.() == "new") {
                        let targetUrl = inputState?.[0]?.["value"]?.pageLink?.replace('#', '') || '/app/data/master/item';
                        if (typeof window.switchWorkspaceModule === 'function') {
                            window.switchWorkspaceModule("MDM", targetUrl);
                        } else {
                            sessionStorage.setItem("pending_admin_navigation", targetUrl);
                            dispatchHandler(dispatch, "getNewMainMenuModulesRequest", {
                                flowType: "MODULES",
                                moduleCode: "MDM",
                                token: sessionStorage.getItem("token"),
                            });
                        }
                    } else {
                        history.push(inputState?.[0]?.["value"]?.pageLink?.replace('#', ''));
                    }
                }
                else {
                    // Navigate to the page for which we selected the excel upload
                    history.push(inputState?.[0]?.["value"]?.pageLink?.replace('#', ''));
                }
                break;
            }
            case "viewExcelLogs": {
                if (isUserCreatingSalesIndent()) {
                    history.push(getMenuMode?.() == 'new' ? '/app/product/digivend/sales/indents' : "/catalogue/indent/historyn")
                } else if (isFromProc) {
                    history.push("/digiproc/excelUploadHistory")
                } else {
                    history.push("/excel-upload-logs")
                }
                break;
            }
            case "viewErrorLogs": {
                setSelectedModal(type);
                setFocusedElement(null);
                break;
            }
            default:
        }
    }

    const renderWizardComponent = () => {
        return <div className={`ue-sec ${stepsComponentClassName}`}>
            <GenericWizardComponent
                outerClassname='!mt-0'
                currentStep={currentStep}
                wizardSteps={{
                    "chooseFile": {
                        label: "Choose File",
                    },
                    "dataPreview": {
                        label: "Data Preview",
                    },
                    "mapColumn": {
                        label: "Map Column",
                    },
                    "dataValidation": {
                        label: "Data Validation"
                    },
                    "summary": {
                        label: "Summary"
                    }
                }}
            />
        </div>
    }

    // Function: To render the header component 
    const renderHeaderComponent = () => {
        switch (currentStep) {
            case 4:
            case 3: {
                return <React.Fragment>
                    <div className='flex items-center justify-between gap-2'>
                        <div className='flex items-center gap-3'>
                            <LanguageTranslator tag="h1">Upload Excel Summary</LanguageTranslator>
                            {(inputState?.[0]?.["value"]?.["value"]) && <div className='flex items-center justify-center px-[15px] py-[5px] rounded-full bg-[#F0F3F6]'>
                                <p className='mb-0 text-xs font-medium text-[#67768E]'>{inputState?.[0]?.["value"]?.["value"] || '-'}</p>
                            </div>}
                        </div>
                        <div className='uploadExcelSummarySection flex items-center whitespace-nowrap'>
                            <UploadExcelInfo />
                            <GenericFormFooterComponent
                                buttons={[
                                    (isRunProcMethods?.() && currentStep === 3 && Object.keys(validateDataResponse || {})?.length > 0 && !isCurrentDataValidated && !isFromProc) && {
                                        type: "rejectOutline",
                                        label: "Error Logs",
                                        onClick: () => handleChange("viewErrorLogs"),
                                        leftIcon: <TriangleAlert size={16} strokeWidth={2.1} color='#FD3757' className='shrink-0' />
                                    },
                                    {
                                        type: "default",
                                        onClick: () => handleChange("viewExcelLogs"),
                                        label: 'View Excel Logs'
                                    },
                                    currentStep !== 4 && {
                                        type: "default",
                                        onClick: () => switchStep("back"),
                                        label: 'Back'
                                    },
                                    currentStep === 3 && {
                                        type: "primary",
                                        label: (configKeys?.EXCEL_VALIDATION_SUBMIT_SEND_TO_QUEUE?.toLowerCase() == "true" && isRunMethodFromDigiProcGenericExcel?.()) ? "Next" : "Validate Excel",
                                        disabled: () => isValidateDisabled,
                                        onClick: () => handleChange("validateFile", false)
                                    },
                                    currentStep == 4 && isRunProcMethods?.() &&{
                                        type: "primary",
                                        label: (["PURCHASE_ORDER", "PURCHASE_ORDER_UPLOAD", "CUSTOM_PURCHASE_ORDER_UPLOAD", "PURCHASE_ORDER_ICODE_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"])) ? "View Orders" : "View Indents",
                                        onClick: () => history?.replace(["PURCHASE_ORDER", "PURCHASE_ORDER_UPLOAD", "CUSTOM_PURCHASE_ORDER_UPLOAD", "PURCHASE_ORDER_ICODE_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) ? getMenuMode?.() == 'new' ? '/app/product/digiproc/purchase/orders' : '/purchase/purchaseOrderHistory' : getMenuMode?.() == 'new' ? '/app/product/digiproc/purchase/indents' : '/purchase/purchaseIndentHistory')
                                    },
                                    currentStep == 4 && isUserCreatingSalesIndent() && {
                                        type: "primary",
                                        label: "View Sales Indents",
                                        onClick: () => history?.replace(getMenuMode?.() == 'new' ? '/app/product/digivend/sales/indents' : '/catalogue/indent/historyn')
                                    },
                                    !(currentStep === 3 && configKeys?.EXCEL_VALIDATION_SUBMIT_SEND_TO_QUEUE?.toLowerCase() == "true" && isRunMethodFromDigiProcGenericExcel?.()) && {
                                        type: "primary",
                                        label: currentStep == 4 ? "Upload Another Excel" : "Next",
                                        loading: buttonLoading,
                                        onClick: () => switchStep("next"),
                                        disabled: () => isNextDisabled()
                                    },
                                ].filter(Boolean)}
                            />
                        </div>
                    </div>
                    <div className='ueh-sec'>
                        <div className='ueh-left mt-[10px] flex items-center gap-4'>
                            {/* Render the summary in case of procurement */}
                            <div className='uehl px-2.5 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                                <div>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'>{currentExcelFile?.length - 1}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='!text-[11px] !font-normal !text-[#4A5D7A]'>Total Items</LanguageTranslator>
                                </div>
                                <div className='h-full flex flex-col justify-end items-center'>
                                    <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><Icons.TotalItems/></div>
                                </div>
                            </div>
                            {(isRunProcMethods?.() || isUserCreatingSalesIndent()) && <div className='uehl px-2.5 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                                <div>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'>{Object.keys(updatedProcExcelData || {})?.length}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='!text-[11px] !font-normal !text-[#4A5D7A]'>{currentExcelFile?.key == "PURCAHSE_INDENT" ? 'Total PI' : 'Total PO'}</LanguageTranslator>
                                </div>
                                <div className='h-full flex flex-col justify-end items-center'>
                                    <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#03B675]'><Icons.TotalPo/></div>
                                </div>
                            </div>}
                            {/* {(isRunProcMethods?.() || isUserCreatingSalesIndent()) && <div className='uehl'>
                                {currentExcelFile?.key == "PURCAHSE_INDENT" ? <h5>Total PI</h5> : <LanguageTranslator tag='h5'>Total PO</LanguageTranslator>}
                                <h3>{Object.keys(updatedProcExcelData || {})?.length}</h3>
                            </div>} */}
                            {!["ADHOC_REQUEST_UPLOAD", "OTB_MANAGE_EXCEL_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) && <div className='uehl px-2.5 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                                <div>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'>{Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalQty || ""), 0)}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='!text-[11px] !font-normal !text-[#4A5D7A]'>Total Quantity</LanguageTranslator>
                                </div>
                                <div className='h-full flex flex-col justify-end items-center'>
                                    <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><ClipboardList size={17} strokeWidth={1.5} color='white' /></div>
                                </div>
                            </div>}
                            {/* <div className='uehl'>
                                <LanguageTranslator tag="h5">Total Quantity</LanguageTranslator>
                                <LanguageTranslator tag="h3">{Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalQty || ""), 0)}</LanguageTranslator>
                            </div> */}
                            {["PURCHASE_INDENT_UPLOAD", "PURCHASE_ORDER_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) && <div className='uehl px-2.5 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                                <div>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'><LanguageTranslator tag="span" className="repee">&#x20B9; </LanguageTranslator> {Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalAmountWithoutTax || ""), 0)}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='!text-[11px] !font-normal !text-[#4A5D7A]'>Total Amount Without Tax</LanguageTranslator>
                                </div>
                                <div className='h-full flex flex-col justify-end items-center'>
                                    <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><HandCoins size={17} strokeWidth={1.5} color='white' /></div>
                                </div>
                            </div>}
                            {!["ADHOC_REQUEST_UPLOAD", "OTB_MANAGE_EXCEL_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) && <div className='uehl px-2.5 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                                <div>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'><LanguageTranslator tag="span" className="repee">&#x20B9; </LanguageTranslator> {Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalNetAmount || ""), 0)}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='!text-[11px] !font-normal !text-[#4A5D7A]'>Total Amount</LanguageTranslator>
                                </div>
                                <div className='h-full flex flex-col justify-end items-center'>
                                    <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><HandCoins size={17} strokeWidth={1.5} color='white' /></div>
                                </div>
                            </div>}
                            {/* <div className='uehl'>
                                <LanguageTranslator tag="h5">Total Amount</LanguageTranslator>
                                <LanguageTranslator tag="h3"><LanguageTranslator tag="span" className="repee">&#x20B9; </LanguageTranslator> {Object?.values(validateDataResponse)?.reduce((a, b) => a + Number(b.totalNetAmount || ""), 0)}</LanguageTranslator>
                            </div> */}
                        </div>
                        <div className='ueh-right mt-[52px] flex items-center gap-2'>
                            {validateDataResponse?.["msg"] && <LanguageTranslator tag='h4' style={{ color: validateDataResponse?.["validation"] == "failed" ? "red" : "green" }}>{validateDataResponse?.["msg"]}</LanguageTranslator>}
                            {/* <GenericInput
                                placeholder="Search Item"
                                iconLeft={<Icons.SearchIcon />}
                                isDisabled={true}
                                genInputExtraClass="!w-[300px]"
                            /> */}
                        </div>
                    </div>
                </React.Fragment>
            }
            default: {
                return <React.Fragment>
                    <div className='flex items-center gap-2 justify-between'>
                        <div className='flex items-center gap-3'>
                            <LanguageTranslator tag="h1">Upload Excel</LanguageTranslator>
                            {(currentStep > 0 && inputState?.[0]?.["value"]?.["value"]) && <div className='flex items-center justify-center px-[15px] py-[5px] rounded-full bg-[#F0F3F6]'>
                                <p className='mb-0 text-xs font-medium text-[#67768E]'>{inputState?.[0]?.["value"]?.["value"] || '-'}</p>
                            </div>}
                        </div>
                        <GenericFormFooterComponent
                            buttons={[
                                {
                                    type: "default",
                                    onClick: () => handleChange("viewExcelLogs"),
                                    label: 'View Excel Logs'
                                },
                                currentStep !== 4 && {
                                    type: "default",
                                    onClick: () => switchStep("back"),
                                    label: 'Back'
                                },
                                currentStep === 3 && {
                                    type: "primary",
                                    label: "Validate Excel",
                                    disabled: () => isValidateDisabled,
                                    onClick: () => handleChange("validateFile", false)
                                },
                                currentStep == 4 && isRunProcMethods?.() && {
                                    type: "primary",
                                    label: ["PURCHASE_ORDER", "PURCHASE_ORDER_UPLOAD", "CUSTOM_PURCHASE_ORDER_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) ? "View Orders" : "View Indents",
                                    onClick: () => history?.replace(["PURCHASE_ORDER", "PURCHASE_ORDER_UPLOAD", "CUSTOM_PURCHASE_ORDER_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) ? getMenuMode?.() == 'new' ? '/app/product/digiproc/purchase/orders' : '/purchase/purchaseOrderHistory' : getMenuMode?.() == 'new' ? '/app/product/digiproc/purchase/indents' : '/purchase/purchaseIndentHistory')
                                },
                                currentStep == 4 && isUserCreatingSalesIndent() && {
                                    type: "primary",
                                    label: "View Sales Indents",
                                    onClick: () => history?.replace(getMenuMode?.() == 'new' ? '/app/product/digivend/sales/indents' : '/catalogue/indent/historyn')
                                },
                                {
                                    type: "primary",
                                    label: currentStep == 4 ? "Upload Another Excel" : "Next",
                                    loading: buttonLoading,
                                    onClick: () => switchStep("next"),
                                    disabled: () => isNextDisabled()
                                },
                            ].filter(Boolean)}
                        />
                    </div>
                    <LanguageTranslator tag="h4">You can upload only in .xlsx, .xls or .csv formats and file size should not exceed 10MB</LanguageTranslator>
                </React.Fragment>
            }
        }
    }

    // Function : TO provide the updated cell classes for the data inside the excel.
    // const provideUpdatedCellClasses = (excelData, validationResponse) => {
    //     let rows = [];
    //     excelData?.map((row, index) => {
    //         let headers = excelData?.[0];
    //         if (!rows[index]) {
    //             rows[index] = [];
    //         }
    //         if (index != 0) {
    //             headers?.map((headerKey, headerIndex) => {
    //                 let code = provideExcelHeaderCode(headerIndex + 1, index);
    //                 if (validationResponse?.["address"]?.["dataIssue"]?.includes(code)) {
    //                     rows[index][headerIndex] = "red";
    //                 } else if (validationResponse?.["address"]?.["mandate"]?.includes(code)) {
    //                     rows[index][headerIndex] = "maroon";
    //                 } else if (validationResponse?.["address"]?.["mismatch"]?.includes(code)) {
    //                     rows[index][headerIndex] = "orange";
    //                 } else if (validationResponse?.["address"]?.["ext"]?.includes(code)) {
    //                     rows[index][headerIndex] = "yellow"
    //                 } else {
    //                     rows[index][headerIndex] = '';
    //                 }
    //             })
    //         } else {
    //             headers?.map(key => rows[index].push(''));
    //         }
    //     });

    //     return rows;
    // }

    useEffect(() => {
        if(focusedElement) {

            setTimeout(() => {
            // Find the cell with the black border (your focus style)
            const targetCell = document.querySelector('.focusedCell');
            if (targetCell) {
                targetCell.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
            }
            }, 100);

        }

    }, [focusedElement]);

    const provideUpdatedCellClasses = (excelData, validationResponse, rowOffset = 0) => {
        let rows = [];
        // Convert the comma-separated addresses to arrays for easier lookup
        const validationAddresses = validationResponse?.address || {};
        const dataIssueAddresses = new Set(validationAddresses?.dataIssue?.split(',') || []);
        const mandateAddresses = new Set(validationAddresses?.mandate?.split(',') || []);
        const mismatchAddresses = new Set(validationAddresses?.mismatch?.split(',') || []);
        const extAddresses = new Set(validationAddresses?.ext?.split(',') || []);
        excelData?.forEach((row, rowIndex) => {
            let headers = excelData?.[0];

            let adjustedRowIndex = rowIndex + rowOffset;

            if (!rows[rowIndex]) {
                rows[rowIndex] = [];
            }

            if (rowIndex !== 0) {
                headers?.forEach((headerKey, headerIndex) => {
                    let code = provideExcelHeaderCode(headerIndex + 1, adjustedRowIndex);
                    // We are working with exact matches
                    if (dataIssueAddresses.has(code)) {
                        rows[rowIndex][headerIndex] = `!bg-[#E1705566] ${focusedElement === code ? "focusedCell !border-2 !border-solid !border-black" : ""}`;
                    } else if (mandateAddresses.has(code)) {
                        rows[rowIndex][headerIndex] = `!bg-[#55555566] ${focusedElement === code ? "focusedCell !border-2 !border-solid !border-black" : ""}`;
                    } else if (mismatchAddresses.has(code)) {
                        rows[rowIndex][headerIndex] = `!bg-[#D6303166] ${focusedElement === code ? "focusedCell !border-2 !border-solid !border-black" : ""}`;
                    } else if (extAddresses.has(code)) {
                        rows[rowIndex][headerIndex] = `!bg-[#FFD17C66] ${focusedElement === code ? "focusedCell !border-2 !border-solid !border-black" : ""}`;
                    } else {
                        rows[rowIndex][headerIndex] = '';
                    }
                });
            } else {
                headers?.forEach(() => rows?.[rowIndex]?.push(''));
            }
        });

        return rows;
    }


    // Function : To provide the excel headers code from the index of the headers of excel sheet
    const provideExcelHeaderCode = (headerIndex, rowIndex) => {
        var str = '', q, r;
        while (headerIndex > 0) {
            q = (headerIndex - 1) / 26;
            r = (headerIndex - 1) % 26
            headerIndex = Math.floor(q)
            str = String.fromCharCode(65 + r) + str;
        }
        return `${str}${rowIndex}`;
    }

    // Function : To render the spreadsheet on the basis of the breakpoint

    const getPreviousKey = (obj, currentKey) => {
        const keys = Object.keys(obj);
        const currentIndex = keys.indexOf(currentKey);

        if (currentIndex > 0) {
            return keys[currentIndex - 1]; // Return the previous key
        } else {
            return null; // Return null if there is no previous key (first key)
        }
    }

    const renderSpreasheetBasedOnBreakpoint = (isFromProc) => {

        if (isFromProc) {
            // Render different section based on the breakpoint data
            let rowOffset = 0;
            return Object.keys(updatedProcExcelData || {})?.map((breakpoint, index) => {
                let validationData = validateDataResponse?.[breakpoint] || {};

                rowOffset += (updatedProcExcelData?.[getPreviousKey(updatedProcExcelData, breakpoint)]?.length - 1) || 0;

                let updatedCellClasses;

                if (currentStep == 3) {
                    updatedCellClasses = provideUpdatedCellClasses(updatedProcExcelData?.[breakpoint], validationData, rowOffset);
                }
                const testVars = {
                    initialData: {
                        rows: updatedProcExcelData?.[breakpoint]
                    },
                    config: {
                        rows: 10,
                        columns: 20,
                        hasHeadColumn: false,
                        isHeadColumnString: false,
                        hasHeadRow: true,
                        isHeadRowString: false,
                        canAddRow: false,
                        canAddColumn: false,
                        emptyValueSymbol: '-',
                        hasLetterNumberHeads: false
                    },
                    cellClasses: {
                        rows: updatedCellClasses || [
                            ['', '', '', '', '', '', '', ''],
                            ['', '', '', '', '', '', '', ''],
                            ['', '', '', '', '', '', '', ''],
                            ['', '', '', '', '', '', '', ''],
                        ]
                    }
                };
                if(generalStore?.["validateGenericExcelSheetData"]?.isLoading || generalStore?.["validateProcExcelData"]?.isLoading) {
                    return null
                }

                return (
                    <div className={`${validationData?.["validation"] == "failed" ? 'border border-[#FD3757] rounded-[5px]' : ''}`}>
                        <div className={`ueu-sec px-5 py-2.5 flex justify-between rounded-[5px] cursor-pointer bg-white`} onClick={() => { setCurrentExpandedBreakpoint(currentExpandedBreakpoint == breakpoint ? "" : breakpoint) }}>
                            <div className='ueus-left flex items-center gap-8'>
                                <div className='ueusl'>
                                    <LanguageTranslator tag="h3" className='mb-1.5 text-base font-semibold text-fontBlack'>{breakpoint}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='mb-0 text-[11px] text-[#4A5D7A]'>Break Point</LanguageTranslator>
                                </div>
                                
                                {/* separator */}
                                <div className='shrink-0 h-[25px] w-[1.5px] bg-[#D9D9D9]'></div>

                                <div className='ueusl'>
                                    <LanguageTranslator tag="h3" className='mb-1.5 text-base font-semibold text-fontBlack'>{updatedProcExcelData?.[breakpoint]?.length > 0 ? updatedProcExcelData?.[breakpoint]?.length - 1 : 0}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='mb-0 text-[11px] text-[#4A5D7A]'>No. of Lineitems uploaded</LanguageTranslator>
                                </div>

                                {/* separator */}
                                <div className='shrink-0 h-[25px] w-[1.5px] bg-[#D9D9D9]'></div>

                                <div className='ueusl'>
                                    <LanguageTranslator tag="h3" className='mb-1.5 text-base font-semibold text-fontBlack'>{validationData?.["totalQty"] || "0"}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='mb-0 text-[11px] text-[#4A5D7A]'>Quantity</LanguageTranslator>
                                </div>

                                <div className='shrink-0 h-[25px] w-[1.5px] bg-[#D9D9D9]'></div>

                                {["PURCHASE_INDENT_UPLOAD", "PURCHASE_ORDER_UPLOAD"]?.includes(inputState?.[0]?.["value"]?.["key"]) && <div className='ueusl'>
                                    <LanguageTranslator tag="h3" className='mb-1.5 text-base font-semibold text-fontBlack'><LanguageTranslator tag="span" className="repee">&#x20B9; </LanguageTranslator> {validationData?.["totalAmountWithoutTax"] || "0"}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='mb-0 text-[11px] text-[#4A5D7A]'>Total Amount Without Tax</LanguageTranslator>
                                </div>}

                                {/* separator */}
                                <div className='shrink-0 h-[25px] w-[1.5px] bg-[#D9D9D9]'></div>

                                <div className='ueusl'>
                                    <LanguageTranslator tag="h3" className='mb-1.5 text-base font-semibold text-fontBlack'><LanguageTranslator tag="span" className="repee">&#x20B9; </LanguageTranslator> {validationData?.["totalNetAmount"] || "0"}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='mb-0 text-[11px] text-[#4A5D7A]'>Total Amount</LanguageTranslator>
                                </div>

                                {/* separator */}
                                <div className='shrink-0 h-[25px] w-[1.5px] bg-[#D9D9D9]'></div>

                                {/* Render the validation data */}
                                <div className='ueusl'>
                                    {validationData?.["msg"] ? <div className='flex items-center gap-2'>
                                        <div className='shrink-0'>
                                            {validationData?.["validation"] === "failed" ? 
                                                // <TriangleAlert size={23} strokeWidth={2.3} fill='#FD3757' color='white' className='mt-[2px] shrink-0' />
                                                <Icons.WarningRedIcon/>
                                            : <div className='p-[4px] h-[20px] w-[20px] rounded-full flex items-center justify-center bg-[#03B675]'><Check color='white' strokeWidth={2.5} /></div>
                                            }
                                        </div>
                                            <LanguageTranslator tag="h4" className={`!pl-0 !font-medium`} style={{ color: validationData?.["validation"] === "failed" ? "#FD3757" : "black" }}>{validationData?.["msg"]}</LanguageTranslator>
                                        </div>
                                        : <div className='flex items-center'><Icons.InfoIconFilledYellow className='shrink-0'/><h4 className='!pl-[6px] text-xs !font-medium'>Not Yet Validated</h4></div>}
                                </div>
                            </div>

                            <div className='flex items-center gap-8'>
                                <div className='ueus-right p-[2px] h-[19px] w-[19px] bg-white border border-black rounded-full flex items-center justify-center cursor-pointer'>
                                    <ChevronDown size={14} strokeWidth={2.25} className={`duration-200 ${currentExpandedBreakpoint == breakpoint ? "rotate-180" : ""}`} />
                                </div>
                            </div>
                        </div>
                        <div className='ueu-scroll bg-white'>
                            {currentExpandedBreakpoint == breakpoint && (
                                // <SpreadsheetComponent
                                //     initialData={testVars.initialData}
                                //     config={testVars.config}
                                //     cellClasses={testVars.cellClasses}
                                //     spreadsheetId="spreadsheet-1"
                                // />
                                <SpreadsheetWithHeaders 
                                    initialData={testVars.initialData}
                                    config={testVars.config}
                                    cellClasses={testVars.cellClasses}
                                    spreadsheetId="spreadsheet-1"
                                    prevRowCount={rowOffset}
                                />
                            )}
                        </div>
                    </div>
                )
            })
        } else {

            let updatedCellClasses;

            if (currentStep == 3) {
                updatedCellClasses = provideUpdatedCellClasses(updatedCurrentExcelFile, validateDataResponse);
            }

            const testVars = {
                initialData: {
                    rows: currentStep === 3 ? updatedCurrentExcelFile != null ? updatedCurrentExcelFile : [] : currentExcelFile != null ? currentExcelFile : [],
                },
                config: {
                    rows: 10,
                    columns: 20,
                    hasHeadColumn: false,
                    isHeadColumnString: false,
                    hasHeadRow: true,
                    isHeadRowString: false,
                    canAddRow: false,
                    canAddColumn: false,
                    emptyValueSymbol: '-',
                    hasLetterNumberHeads: false
                },
                cellClasses: {
                    rows: currentStep == 3 && updatedCellClasses ? updatedCellClasses : [
                        ['', '', '', '', '', '', '', ''],
                        ['', '', '', '', '', '', '', ''],
                        ['', '', '', '', '', '', '', ''],
                        ['', '', '', '', '', '', '', ''],
                    ]
                }
            };
            if(generalStore?.["validateGenericExcelSheetData"]?.isLoading) {
                return null
            }
            return <SpreadsheetWithHeaders 
                initialData={testVars.initialData}
                config={testVars.config}
                cellClasses={testVars.cellClasses}
                spreadsheetId="spreadsheet-1"
            />
            // return <SpreadsheetComponent
            //     initialData={testVars.initialData}
            //     config={testVars.config}
            //     cellClasses={testVars.cellClasses}
            //     spreadsheetId="spreadsheet-1"
            // />
        }
    }

    const renderExcelComponent = () => {
        switch (currentStep) {
            case 0: {
                return renderChooseFileComponent()
            }
            case 1: {
                return <div id="spreadsheet" className="eupbc-table !w-auto mx-4 bg-white rounded-md" style={{ width: "100%", height: "60%" }}>
                    {renderSpreasheetBasedOnBreakpoint()}
                </div>
            }
            case 2: {
                return <div className='mt-[12px] mx-4 rounded-md bg-white'>
                    <GenericFormComponent
                        rowInput={{
                            rowType: "singleRow",
                            availableInputs: getInputFields(),
                            inputState: { ...inputState?.[2] || {} },
                            inputStateChangeFunction: (data) => {
                                let updatedInputData = [...inputState];
                                updatedInputData[2] = data;
                                updateInputState(updatedInputData);
                            },
                            errorData: { ...errorData?.[2] || {} },
                            updateErrorData: (data) => {
                                let updatedErrorData = [...errorData];
                                updatedErrorData[2] = data;
                                setErrorData(updatedErrorData);
                            }
                        }}
                    />
                </div>
            }
            case 3: return <div id="spreadsheet" className="eupbc-table space-y-3">
                {renderSpreasheetBasedOnBreakpoint(isRunProcMethods?.() || isUserCreatingSalesIndent())}
                {focusedElement && <div className='py-3 fixed z-[1] bottom-[40px] left-1/2 -translate-x-1/2 w-auto flex justify-center items-center gap-2'>
                    <div className='rounded-[3px]' style={{boxShadow: '0px 0px 4px 0px #00000026'}}>
                        <GenericCustomButton type="rejectOutline" onClick={() =>setSelectedModal("viewErrorLogs")} label="Return to Error Logs" leftIcon={<Undo2 size={18} color='#FD3757' />} />
                    </div>
                    <div className='bg-white rounded-[3px] h-[17px]' style={{boxShadow: '0px 0px 4px 0px #00000026'}}>
                        <GenericCustomButton onClick={() => setFocusedElement(null)} leftIcon={<X size={16} strokeWidth={2.25} />} className='p-[1px] hover:opacity-75' />
                    </div>
                </div>}
            </div>;
            case 4: {
                return (
                    // <div className='upload-completed'>
                    //     <div className='upc-head'>
                    //         <svg className="uploaded-checked-logo" width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //             <path fillRule="evenodd" clipRule="evenodd" d="M0.980713 25.1003C0.980713 11.5069 12.0003 0.487305 25.5937 0.487305C39.1872 0.487305 50.2068 11.5069 50.2068 25.1003C50.2068 38.6937 39.1872 49.7134 25.5937 49.7134C12.0003 49.7134 0.980713 38.6937 0.980713 25.1003Z" fill="#03B675" />
                    //             <path fillRule="evenodd" clipRule="evenodd" d="M37.477 16.2464C38.3508 17.1202 38.3508 18.5369 37.477 19.4107L23.5883 33.9548C22.7145 34.8286 21.2977 34.8286 20.4239 33.9548L13.7113 27.2421C12.8375 26.3683 12.8375 24.9516 13.7113 24.0778C14.5851 23.204 16.0018 23.204 16.8756 24.0778L22.0061 29.2082L34.3126 16.2464C35.1864 15.3725 36.6032 15.3725 37.477 16.2464Z" fill="white" />
                    //         </svg>
                    //         <div className='text-area'>
                    //             <LanguageTranslator tag="p">Upload Completed</LanguageTranslator>
                    //             <LanguageTranslator tag="h3">{inputState?.[0]?.["value"]?.["value"]}</LanguageTranslator>
                    //         </div>
                    //         <div className="upload-items">
                    //             <LanguageTranslator tag="p">Total Uploaded items</LanguageTranslator>
                    //             <LanguageTranslator tag="label">{isRunProcMethods?.() || isUserCreatingSalesIndent() ? (Number(Object.keys(updatedProcExcelData || {})?.length)) : (Number(updatedCurrentExcelFile?.length || "") - 1)}</LanguageTranslator>
                    //         </div>
                    //         <div className='total-item'>
                    //             <LanguageTranslator tag="p">Ref Number</LanguageTranslator>
                    //             <input type="text" autoComplete="off" disabled value={inputState?.[4]?.["refNo"]} id="myInput"></input>
                    //             {copied ?
                    //                 <span className='copy-successed'>Copied to Clipboard</span>
                    //                 :
                    //                 <button onClick={() => handleCopy(inputState?.[4]?.["refNo"])}>
                    //                     <Icons.CopyIcon />
                    //                     <LanguageTranslator tag="span" className="generic-tooltip">Copy UUID</LanguageTranslator>
                    //                 </button>
                    //             }

                    //         </div>
                    //     </div>
                    //     {inputState?.[0]?.["value"]?.pageLink && <div className='view-link-btn'>
                    //         <LanguageTranslator tag="span" className='vbp-btn' onClick={() => handleChange("viewExcelUploadedPages")}>View {inputState?.[0]?.["value"]?.["value"]}</LanguageTranslator>
                    //     </div>}
                    // </div>
                    <div className='mt-[8px] 2xl:mt-[12px] mx-4 px-[15px] py-6 2xl:py-10 border border-borderSlateGrey bg-[#FAFAFA] rounded-md flex flex-col justify-center items-center'>
                        <div className='mb-[18px] p-[6px] w-fit rounded-full shrink-0 bg-[#03B675] ring-4 ring-[#03B675] ring-opacity-10'><Check color='white' size={40} className='shrink-0' /></div>
                        <LanguageTranslator tag="h3" className='text-xs 2xl:text-[13px] font-medium'>{inputState?.[0]?.["value"]?.["value"]}</LanguageTranslator>
                        <p className='mb-4 2xl:mb-7 text-lg 2xl:text-xl font-semibold text-[#111D31]'>Upload Completed Successfully</p>

                        <div className={`px-3.5 py-3 flex items-start gap-7 bg-white rounded-md ${inputState?.[0]?.["value"]?.pageLink ? 'mb-8' : 'mb-4'}`}>
                            {inputState?.[4]?.["refNo"] && <>
                                <div className='min-w-[200px]'>
                                    <LanguageTranslator tag="p" className='mb-1.5 2xl:mb-2 text-xs text-[#67768E]'>Reference Number/UUID</LanguageTranslator>
                                    <div className='flex items-center gap-2.5'>
                                        <div className='px-1 bg-[#E5E7EB] rounded-[3px]'>
                                            <input className='text-[13px] font-semibold' type="text" autoComplete="off" disabled value={inputState?.[4]?.["refNo"]} id="myInput"></input>
                                        </div>
                                        {copied ?
                                            <CheckCheck size={18} color='#03B675' />
                                            :
                                            <button onClick={() => handleCopy(inputState?.[4]?.["refNo"])}>
                                                <Icons.CopyIcon />
                                                <LanguageTranslator tag="span" className="generic-tooltip">Copy UUID</LanguageTranslator>
                                            </button>
                                        }
                                    </div>
                                </div>

                                <div className='h-[48px] w-[1px] shrink-0 bg-[#ECEDF7]'></div>
                            </>

                            }

                            <div className='min-w-[190px]'>
                                <LanguageTranslator tag="p" className={`mb-1.5 2xl:mb-2 text-xs text-[#67768E] ${inputState?.[4]?.["refNo"] ? '' : 'text-center'}`}>Number of Uploaded Items</LanguageTranslator>
                                <LanguageTranslator tag="label" className={`mb-0 text-[13px] font-semibold ${inputState?.[4]?.["refNo"] ? '' : 'text-center w-full'}`}>{isRunProcMethods?.() || isUserCreatingSalesIndent() ? (Number(Object.keys(updatedProcExcelData || {})?.length)) : (Number(updatedCurrentExcelFile?.length || "") - 1)}</LanguageTranslator>
                            </div>                            
                        </div>
                        {inputState?.[0]?.["value"]?.pageLink && 
                            <GenericCustomButton
                                type='default'
                                label={`View ${inputState?.[0]?.["value"]?.["value"]}`}
                                onClick={() => handleChange("viewExcelUploadedPages")}
                                className='min-w-[240px]'
                            />
                        }
                    </div>
                )
            }
            default: {
                <NoDataFound />
            }
        }
    }

    // Render the choose file component when the currentStep value is 0
    const renderChooseFileComponent = () => {
        return generalStore?.["getGenericExcelTemplateData"]?.isLoading ? <UploadExcelSkeletons step={currentStep} /> : <div className={`relative ${mode === 'procLineItemExcel' ? 'h-full' : 'p-[15px]'}`}>
            {/* {Object.keys(lastUploadedFile || {})?.length > 0 && <div className="col-lg-4 col-md-4 col-sm-12 p-0">
                <div className="cdu-right text-fontBlack flex flex-col items-center">
                    <div className="cdur-uploaded-file flex items-center gap-2 mb-2">
                        <IconsPath.WarningYellowIcon height={20} width={20} />
                        <span className='text-xs'>Previously Uploaded File Found</span>
                    </div>
                    <div className="cdur-selected-file mb-4">
                        <p className='font-medium text-[13px]'> {lastUploadedFile?.file_name || ""}</p>
                        <span className="cdursf-last-mod text-xs text-fontGrey">Last Modified: <span className="cdursf-time text-fontBlack">{lastUploadedFile?.modifed_on || ""}</span></span>
                    </div>
                    <a href={lastUploadedFile.file_path} download>
                        <GenericCustomButton
                            className="cdur-download-now"
                            type='success'
                            label={"Download Now"}
                        />
                    </a>
                </div>
            </div>} */}

            <div className={`bg-white rounded-[10px] ${mode === 'procLineItemExcel' ? 'h-full !pb-2' : ''}`}>
                <GenericFormComponent
                    className={mode === 'procLineItemExcel' ? '!h-full' : ''}
                    rowInput={{
                        rowRightExtras: () => Object.keys(lastUploadedFile || {})?.length > 0 ? <div className={`w-full ${mode === 'procLineItemExcel' ? '-mt-[420px]' : inputState?.[0]?.uploadFile ? '-mt-[400px]' : '-mt-[370px]'} text-center`}><div className="col-lg-4 col-md-4 col-sm-12 float-end border-l border-[#DAE4EE] !pl-5 pr-1">
                            <div className="cdu-right text-fontBlack flex flex-col items-center">
                                <div className="cdur-uploaded-file flex items-center gap-1 mb-2 px-2 py-1 borderborder" style={{ boxShadow: '0 0 8px #d6d9e4' }}>
                                    <IconsPath.WarningYellowIcon height={20} width={20} />
                                    <span className='text-[11px]'>Previously Uploaded File Found</span>
                                </div>
                                <div className="cdur-selected-file mb-2">
                                    <p className='font-medium text-xs mb-0 max-w-[200px] truncate'> {lastUploadedFile?.file_name || ""}</p>
                                    <span className="cdursf-last-mod text-fontGrey text-[10px]">Last Modified: <span className="cdursf-time text-fontBlack">{lastUploadedFile?.modified_on || ""}</span></span>
                                </div>
                                <a href={lastUploadedFile.file_path} download>
                                    <GenericCustomButton
                                        className="cdur-download-now !text-[11px] !h-[28px] !rounded-md"
                                        type='success'
                                        label={"Download Now"}
                                    />
                                </a>
                            </div>
                        </div></div> : null,
                        rowType: "spread",
                        availableInputs: getInputFields(),
                        inputState: { ...inputState?.[0] || {} },
                        inputStateChangeFunction: (data) => {
                            let updatedInputData = [...inputState];
                            updatedInputData[0] = data;
                            updateInputState(updatedInputData);
                        },
                        errorData: { ...errorData?.[0] || {} },
                        updateErrorData: (data) => {
                            let updatedErrorData = [...errorData];
                            updatedErrorData[0] = data;
                            setErrorData(updatedErrorData);
                        }
                    }}
                />
            </div>

        </div>
    }

    const getParentChildProps = () => {
        let payload = {
            closeModal: () => { setSelectedModal(false) },
            animationType: "bottom",
        }

        let confirmationModalPayload = {
            ...payload,
            // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: "fixed", borderRadius: 4 },
            parentModalOuterMostClassName: 'flex items-center justify-center',
            postitionProps: { position: 'relative' },
            dimensions: { width: "36vw", height: "36vh", maxHeight: '320px', maxWidth: '540px' },
            icon: () => { return <IconsPath.ConfirmationModalImg /> },
        }

        switch (selectedModal) {
            case "backConfirmationModal": {
                return {
                    ...confirmationModalPayload,
                    labelComponent: "Are you sure you want to go back?, as all the data edited will be lost!",
                    buttons: [
                        {
                            type: 'default',
                            label: "No, wait",
                            onClick: () => { setSelectedModal(false) }
                        },
                        {
                            type: 'primary',
                            label: "Sure, Yes",
                            onClick: () => {
                                history?.goBack?.()
                            },
                        },
                    ]
                }
            }
            case "confirmationModal": {
                return {
                    ...confirmationModalPayload,
                    labelComponent: "Are you sure you want to go back to Map Column, as all the data edited will be lost!",
                    buttons: [
                        {
                            type: 'default',
                            label: "No, wait",
                            onClick: () => { setSelectedModal(false) }
                        },
                        {
                            type: 'primary',
                            label: "Sure, Yes",
                            onClick: () => {
                                setCurrentStep(currentStep - 1);
                                setSelectedModal(false);
                                setIsValidateDisabled(false);
                                setIsCurrentDataValidated(false);
                                setValidateDataResponse({})
                                setCurrentExpandedBreakpoint("");
                                setSubmitLoading(false);
                            },
                        },
                    ]
                }
            }
            case "processNextWithFailedValidation": {
                return {
                    ...confirmationModalPayload,
                    labelComponent: "Validation completed with some errors. Only successfully validated rows will be processed. Do you want to continue?!",
                    buttons: [

                        {
                            label: "No, wait",
                            type : 'default',
                            onClick: () => { setSelectedModal(false) }
                        },
                        {
                            label: "Sure, Yes",
                            type : 'primary',
                            onClick: () => finalSubmitWithFailValidation(),
                        }
                    ]
                }
            }
            case "viewErrorLogs": {
                return {
                    postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", position: "absolute", margin: 0, borderRadius: 0 },
                    dimensions: { width: "500px", height: "100vh" },
                    animationType: "right",
                    closeModal: () => { setSelectedModal("") },
                    selectedData: validateDataResponse,
                    focusedElement,
                    setFocusedElement,
                    setCurrentExpandedBreakpoint,
                    currentTab,
                    setCurrentTab
                }
            }
            default: {
                break;
            }
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "backConfirmationModal":
            case "confirmationModal": case "processNextWithFailedValidation": {
                return GenericConfirmationModal
            }
            case "viewErrorLogs": return ErrorLogsDetails;
            default:
        }
    }

    return (
        <>
        <div className={`upload-excel ${className}`}>
            {/* Render the wizard component here */}
            {renderWizardComponent()}

            <div className='ue-head'>
                {/* Render the header component of the upload excel */}
                <div className='p-[15px] bg-white rounded-[10px]'>
                    {renderHeaderComponent()}
                </div>
            </div>

            <div className={`ue-upload ${mode === 'procLineItemExcel' ? '!h-full !max-h-none' : ''} ${currentStep === 3 ? 'ue-upload-small-height' : ''}`}>
                {/* Render the main component  */}
                {renderExcelComponent()}
            </div>

            {/* Render the final submit buttons for upload excel */}
            {/* {renderBottomSection()} */}

            
        </div>
        {selectedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false) }}
            />}
            </>
    )
}

export default UploadExcel